<template>
  <div class="app-screen-tips">
    <div class="app-screen-tips-content">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.app-screen-tips {
  @apply fixed top-0 h-screen w-screen left-0 z-[999] bg-background;
}
.app-screen-tips-content {
  @apply mx-auto w-[90%] h-full flex flex-col items-center justify-center;
}
</style>
